import * as Yup from "yup";

let validationSchema = Yup.object({
  
  password: Yup.string().required("Password is Required"),
  confirmPassword: Yup.string().required("Confirm Password is Required"),
});
export default validationSchema;
